import { Injectable } from "@angular/core";
import { PreloadingStrategy, Route, Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { AuthService } from "../services/auth.service";
import { ACK_LINK_ROUTE_SEGMENT } from "../shared/constants/alertResponse.constants";

const PUBLIC_LINK_PREFIXES = [`/${ACK_LINK_ROUTE_SEGMENT}/`, "/alert-response/"];

@Injectable({ providedIn: "root" })
export class AuthenticatedPreloadingStrategy implements PreloadingStrategy {
  constructor(private authService: AuthService, private router: Router) {}

  preload(_route: Route, load: () => Observable<unknown>): Observable<unknown> {
    const onPublicLink = PUBLIC_LINK_PREFIXES.some((prefix) => this.router.url.startsWith(prefix));
    return !onPublicLink && this.authService.isLoggedIn() ? load() : of(null);
  }
}
